import _ from 'lodash'

export default function urlBuilder(item, url) {
  const pageUseVendingLayout = _.get(item, 'configOptions.pageUseVendingLayout') === 'true'
  let result = item.url
  if (!_.isEmpty(item.code)) {
    result = `${url}/${item.code}/`
  } else if (_.isString(item)) {
    result = `${url}/${item}/`
  }
  if (pageUseVendingLayout) {
    result = `${result}?vending=1`
  }
  return result
}
